import { createSlice } from "@reduxjs/toolkit";

const superAdminJobsSlice = createSlice({
    name: "super admin jobs",
    initialState: {
        //                             view applicants                                   //
        category: "All",
        job_id: null,
        initialGlow: false,
        categoryChangingGlow: false,
        showFilterBox: false,
        sortBy: "",
        search: "",
        filter_parameters: {},
        seleced_filter_data: {},
        filter_location_search: null,
        candidateData: {},
        job_status: "",
        candidatesList: [],
        candidatesListNoNMutable: [],
        candidate_job_role: '',


        //                               Invited applicants                                   //
        invited_applicats: [],
        invited_applicats_immutable: [],
        invited_applicats_count: 0,
        applicant_search_value: '',
        applicants_filter_status: "All",
        professional_id: null,
        isSearched: false
    },

    reducers: {
        //                                                                 view applicants                                   //
        //Applicants get request
        updateJobGetRequest(state, action) {
            return {
                ...state,
                sortBy: "",
                search: "",
                category: "All",
                filter_parameters: [],
                candidateData: {},
                candidatesList: [],
                candidate_job_role: '',
                category: action.payload?.status,
                initialGlow: true,
                job_id: action.payload?.job_id,
                seleced_filter_data: {},
                showFilterBox: false
            }
        },
        updateJobGetResponse(state, action) {
            const SkillsConvertion = action?.payload?.filter_parameters.skill?.sort()?.map((v, i) => {
                return { value: i + 1, label: v, disabled: false };
            });

            const locationConvertion = action?.payload?.filter_parameters.skill?.sort()?.map((v, i) => {
                return { value: i + 1, label: v, disabled: false };
            });

            const getJobRole = action?.payload?.job_list?.filter((v) => v?.id === state?.job_id)

            return {
                ...state,
                initialGlow: false,
                categoryChangingGlow: false,
                filter_parameters: { skill: SkillsConvertion, location: locationConvertion },
                candidateData: action.payload,
                job_status: action.payload?.job_status,
                candidatesList: action.payload?.candidates_short_desc,
                candidatesListNoNMutable: action.payload?.candidates_short_desc,
                candidate_job_role: getJobRole[0]?.job_title || ''
            }
        },
        updateJobGetFailure(state, action) {
            return {
                ...state,
                initialGlow: false,
                categoryChangingGlow: false
            }
        },

        //Change category
        updateCategoryRequest(state, action) {
            return {
                ...state,
                categoryChangingGlow: true,
                category: action.payload?.status,
                sortBy: "",
                search: "",
                seleced_filter_data: {},
                showFilterBox: false,
            }
        },
        updateCategoryResponse(state, action) {
            return {
                ...state,
                categoryChangingGlow: false,
                candidateData: action.payload || {},
                candidatesList: action.payload?.candidates_short_desc || [],
            }
        },
        updateCategoryFailure(state, action) {
            return {
                ...state,
                categoryChangingGlow: false
            }
        },

        //Show or Hide Filter
        updateFilterVisibility(state, action) {
            return {
                ...state,
                showFilterBox: action.payload
            }
        },

        //Sort by
        updateSortBy(state, action) {
            return {
                ...state,
                search: "",
                category: "All",
                sortBy: action.payload.sortBy,
                seleced_filter_data: {},
                candidatesList: action.payload?.candidatesList,
            }
        },

        //Search results
        updateSearchResults(state, action) {
            return {
                ...state,
                sortBy: "",
                category: "All",
                seleced_filter_data: {},
                search: action.payload?.searchValue,
                candidatesList: action.payload?.candidatesList,
            }
        },

        //Individual select candidate
        updateIndividualRequest(state, action) {
            return {
                ...state,
                categoryChangingGlow: true
            }
        },
        updateIndividualResponse(state, action) {
            return {
                ...state,
                categoryChangingGlow: false,
                candidateData: action.payload
            }
        },
        updateIndividualFailure(state, action) {
            return {
                ...state,
                categoryChangingGlow: false
            }
        },
        updateFilterData(state, action) {
            switch (action.payload?.field) {
                case "location_push":
                    const updatelocation = state?.seleced_filter_data?.location ? [...state?.seleced_filter_data?.location] : []
                    if (action.payload?.location) {
                        if (!state?.seleced_filter_data?.location?.includes(action.payload?.location)) {
                            updatelocation[updatelocation.length] = action.payload?.location;
                        }
                    }

                    return {
                        ...state,
                        seleced_filter_data: {
                            ...state.seleced_filter_data,
                            location: updatelocation || [],
                        },
                        filter_location_search: null
                    }

                case "location_delete":
                    const updatelocationDeleted = action.payload?.location;

                    return {
                        ...state,
                        seleced_filter_data: {
                            ...state.seleced_filter_data,
                            location: updatelocationDeleted || [],
                        },
                        filter_location_search: null
                    }

                case "skills":
                    return {
                        ...state,
                        seleced_filter_data: {
                            ...state.seleced_filter_data,
                            skill: action.payload?.skills || []
                        },
                        filter_parameters: {
                            ...state.filter_parameters,
                            skill: action.payload?.skills_checked || []
                        }
                    }

                default:
                    break;
            }
        },
        updateFilterLocationSearch(state, action) {
            return {
                ...state,
                filter_location_search: action.payload
            }
        },

        //Apply filter
        applyFilterRequest(state, action) {
            return {
                ...state,
                categoryChangingGlow: true,
                category: "All",
                sortBy: "",
                search: "",
                showFilterBox: false,
            }
        },
        applyFilterResponse(state, action) {
            return {
                ...state,
                categoryChangingGlow: false,
                candidateData: action.payload || {},
                candidatesList: action.payload?.candidates_short_desc || [],
            }
        },
        applyFilterFailure(state, action) {
            return {
                ...state,
                categoryChangingGlow: false
            }
        },

        //                                                                Invited Applicants                                   //
        //Invited Applicants
        getInvitedApplicantsRequest(state, action) {
            return {
                ...state,
                initialGlow: true,
                isSearched: false,
                applicant_search_value: '',
                applicants_filter_status: "All",
            }
        },
        getInvitedApplicantsResponse(state, action) {
            return {
                ...state,
                initialGlow: false,
                invited_applicats: action.payload?.final_result || [],
                invited_applicats_immutable: action.payload?.final_result || [],
                candidate_job_role: action.payload?.job_title || '',
                invited_applicats_count: action.payload?.total_professionals || 0
            }
        },
        getInvitedApplicantsFailure(state, action) {
            return {
                ...state,
                initialGlow: false
            }
        },

        //Applicants fiilter
        updateInvitedApplicantFilterStatus(state, action) {
            return {
                ...state,
                applicants_filter_status: action.payload?.status || '',
                invited_applicats: action.payload?.data || []
            }
        },

        //view full profile 
        updateShowEmployerDetails(state, action) {
            return {
                ...state,
                professional_id: action.payload
            }
        },

        //Applicants search
        updateApplicantSearch(state, action) {
            return {
                ...state,
                applicant_search_value: action.payload
            }
        },
        applicantSearchRequest(state, action) {
            return {
                ...state,
                initialGlow: true,
                applicants_filter_status: "All"
            }
        },
        applicantSearchResponse(state, action) {
            return {
                ...state,
                initialGlow: false,
                isSearched: true,
                invited_applicats: action.payload?.final_result || [],
                invited_applicats_immutable: action.payload?.final_result || [],
                invited_applicats_count: action.payload?.total_professionals || 0
            }
        },
        applicantSearchFailure(state, action) {
            return {
                ...state,
                initialGlow: false
            }
        }
    }
})


const { actions, reducer } = superAdminJobsSlice;


export const {
    updateJobGetRequest,
    updateJobGetResponse,
    updateJobGetFailure,
    updateCategoryRequest,
    updateCategoryResponse,
    updateCategoryFailure,
    updateFilterVisibility,
    updateSortBy,
    updateSearchResults,
    updateIndividualRequest,
    updateIndividualResponse,
    updateIndividualFailure,
    updateFilterData,
    updateFilterLocationSearch,
    applyFilterRequest,
    applyFilterResponse,
    applyFilterFailure,
    getInvitedApplicantsRequest,
    getInvitedApplicantsResponse,
    getInvitedApplicantsFailure,
    updateInvitedApplicantFilterStatus,
    updateShowEmployerDetails,
    updateApplicantSearch,
    applicantSearchRequest,
    applicantSearchResponse,
    applicantSearchFailure

} = actions;

export default reducer;